export { ExternalLink } from './ExternalLink'
export type { ExternalLinkProps } from './ExternalLink'
